import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  useTheme,
  Typography,
  MenuItem,
  Menu,
  Button,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import React from "react";
import { useEffect } from "react";
import axios from "axios";

const DateMenu = ({ durationGet, showDates }) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [dayShow, setDayShow] = React.useState(true);
  const [weekShow, setWeekShow] = React.useState(false);
  const [monthShow, setMonthShow] = React.useState(false);
  const [threeMonthsShow, setThreeMonthsShow] = React.useState(false);
  const [sixMonthsShow, setSixMonthsShow] = React.useState(false);
  const [cardText, setCardText] = React.useState("Day");
  const [updatedDate, setUpdatedDate] = React.useState({
    updated_date: new Date(),
  });

  useEffect(() => {
    axios.get("/api/purchase/last_update").then((res) => {
      setUpdatedDate(res.data);
    });
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDay = () => {
    setDayShow(true);
    setWeekShow(false);
    setThreeMonthsShow(false);
    setMonthShow(false);
    setSixMonthsShow(false);
    setAnchorEl(null);
    setCardText("Day");
  };

  const handleMonth = () => {
    setDayShow(false);
    setWeekShow(false);
    setThreeMonthsShow(false);
    setMonthShow(true);
    setSixMonthsShow(false);
    setAnchorEl(null);
    setCardText("Month");
  };

  const handleWeek = () => {
    setDayShow(false);
    setWeekShow(true);
    setThreeMonthsShow(false);
    setMonthShow(false);
    setSixMonthsShow(false);
    setAnchorEl(null);
    setCardText("Week");
  };
  const handleThreeMonths = () => {
    setDayShow(false);
    setWeekShow(false);
    setMonthShow(false);
    setThreeMonthsShow(true);
    setSixMonthsShow(false);
    setAnchorEl(null);
    setCardText("Three Months");
  };

  const handleSixMonths = () => {
    setDayShow(false);
    setWeekShow(false);
    setMonthShow(false);
    setThreeMonthsShow(false);
    setSixMonthsShow(true);
    setAnchorEl(null);
    setCardText("Six Months");
  };
  const LastTransactions = new Date(updatedDate.updated_date);
  const [startDate, setStartDate] = React.useState("");
  const [startDateLastYear, setstartDateLastYear] = React.useState("");
  const [startDateTwoYearsAgo, setStartDateTwoYearsAgo] = React.useState("");

  var month = LastTransactions.getUTCMonth();
  var monthInteger = LastTransactions.getMonth();
  var year = LastTransactions.getUTCFullYear();

  var endDate =
    new Date(LastTransactions).toLocaleString("default", { month: "short" }) +
    " " +
    LastTransactions.getUTCDate() +
    " " +
    year;
  var lastYear = year - 1;
  var TwoYearsAgo = year - 2;

  var endDateLastYear =
    new Date(LastTransactions).toLocaleString("default", { month: "short" }) +
    " " +
    LastTransactions.getUTCDate() +
    " " +
    lastYear;

  var endDateTwoYearsAgo =
    new Date(LastTransactions).toLocaleString("default", { month: "short" }) +
    " " +
    LastTransactions.getUTCDate() +
    " " +
    TwoYearsAgo;

  React.useEffect(() => {
    if (year % 100 === 0 ? year % 400 === 0 : year % 4 === 0) {
      var leapYear = true;
    }

    if (dayShow) {
      var startMonth = month;
      let startDay = LastTransactions.getUTCDate();

      startMonth = new Date(year, startMonth, startDay).toLocaleString(
        "default",
        { month: "short" },
      );
      setStartDate(startMonth + " " + startDay + " " + year);

      if (!leapYear || startDay != 29) {
        lastYear = year - 1;
        setstartDateLastYear(startMonth + " " + startDay + " " + lastYear);
        TwoYearsAgo = year - 2;
        setStartDateTwoYearsAgo(
          startMonth + " " + startDay + " " + TwoYearsAgo,
        );
      } else {
        lastYear = year - 1;
        setstartDateLastYear(
          startMonth + " " + (startDay - 1).toString() + " " + lastYear,
        );
        TwoYearsAgo = year - 2;
        setStartDateTwoYearsAgo(
          startMonth + " " + (startDay - 1).toString() + " " + TwoYearsAgo,
        );
      }
    } else if (weekShow) {
      startMonth = month;
      let startDay = LastTransactions.getUTCDate() - 6;
      if (startDay <= 0) {
        startDay = new Date(year, month, 0).getDate() + startDay;

        startMonth = startMonth - 1;
        if (startMonth < 0) {
          year = year - 1;
          startMonth = 11;
        }
      }
      startMonth = new Date(year, startMonth, startDay).toLocaleString(
        "default",
        { month: "short" },
      );
      setStartDate(startMonth + " " + startDay + " " + year);
      lastYear = year - 1;

      if (!leapYear || startDay != 29) {
        lastYear = year - 1;
        setstartDateLastYear(startMonth + " " + startDay + " " + lastYear);
        TwoYearsAgo = year - 2;
        setStartDateTwoYearsAgo(
          startMonth + " " + startDay + " " + TwoYearsAgo,
        );
      } else {
        lastYear = year - 1;
        setstartDateLastYear(
          startMonth + " " + (startDay - 1).toString() + " " + lastYear,
        );
        TwoYearsAgo = year - 2;
        setStartDateTwoYearsAgo(
          startMonth + " " + (startDay - 1).toString() + " " + TwoYearsAgo,
        );
      }
    } else if (monthShow) {
      let startDay = LastTransactions.getUTCDate();
      startMonth = month;
      if (startMonth < 0) {
        year = year - 1;
        startMonth = 11;
      }
      startMonth = new Date(year, startMonth, 1).toLocaleString("default", {
        month: "short",
      });
      setStartDate(startMonth + " " + 1 + " " + year);
      lastYear = year - 1;

      if (!leapYear || startDay != 29) {
        lastYear = year - 1;
        setstartDateLastYear(startMonth + " " + 1 + " " + lastYear);
        TwoYearsAgo = year - 2;
        setStartDateTwoYearsAgo(startMonth + " " + 1 + " " + TwoYearsAgo);
      } else {
        lastYear = year - 1;
        setstartDateLastYear(startMonth + " " + 1 + " " + lastYear);
        TwoYearsAgo = year - 2;
        setStartDateTwoYearsAgo(startMonth + " " + 1 + " " + TwoYearsAgo);
      }
    } else if (threeMonthsShow) {
      let startDay = LastTransactions.getUTCDate();
      startMonth = month - 2;
      if (startMonth < 0) {
        year = year - 1;
        startMonth = 12 + startMonth;
      }
      startMonth = new Date(year, startMonth, 1).toLocaleString("default", {
        month: "short",
      });
      setStartDate(startMonth + " " + 1 + " " + year);
      lastYear = year - 1;

      if (!leapYear || startDay != 29) {
        lastYear = year - 1;
        setstartDateLastYear(startMonth + " " + 1 + " " + lastYear);
        TwoYearsAgo = year - 2;
        setStartDateTwoYearsAgo(startMonth + " " + 1 + " " + TwoYearsAgo);
      } else {
        lastYear = year - 1;
        setstartDateLastYear(startMonth + " " + 1 + " " + lastYear);
        TwoYearsAgo = year - 2;
        setStartDateTwoYearsAgo(startMonth + " " + 1 + " " + TwoYearsAgo);
      }
    } else {
      startMonth = month - 5;
      if (startMonth <= 0) {
        year = year - 1;
        startMonth = 12 + startMonth;
      }
      startMonth = new Date(year, startMonth, 1).toLocaleString("default", {
        month: "short",
      });
      setStartDate(startMonth + " " + 1 + " " + year);
      lastYear = year - 1;
      setstartDateLastYear(startMonth + " " + 1 + " " + lastYear);
      TwoYearsAgo = year - 2;
      setStartDateTwoYearsAgo(startMonth + " " + 1 + " " + TwoYearsAgo);
    }
  });

  const handleClose = (e) => {
    setAnchorEl(null);
  };

  durationGet(dayShow, weekShow, monthShow, threeMonthsShow, sixMonthsShow);
  return (
    <>
      <Card>
        <CardHeader
          title="Duration"
          action={
            <Button
              id="thisYear"
              endIcon={<ArrowDropDownIcon />}
              size="small"
              variant="text"
              onClick={handleClick}
            >
              {cardText}
            </Button>
          }
        />
        <Menu
          id="this-year"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem id="daily" onClick={handleDay}>
            Day{" "}
          </MenuItem>
          <MenuItem id="currentWeek" onClick={handleWeek}>
            Week{" "}
          </MenuItem>
          <MenuItem id="currentMonth" onClick={handleMonth}>
            Month
          </MenuItem>
          <MenuItem id="treeMonths" onClick={handleThreeMonths}>
            Three Months
          </MenuItem>
          <MenuItem id="sixMonths" onClick={handleSixMonths}>
            Six Months
          </MenuItem>
        </Menu>

        <Divider />
        <CardContent>
          {showDates && (
            <>
              <Typography color="#0D830F" variant="h6" sx={{ mt: 3 }}>
                {startDateTwoYearsAgo + "- " + endDateTwoYearsAgo}
              </Typography>
              <Typography color="#86086D" variant="h6">
                {startDateLastYear + "- " + endDateLastYear}
              </Typography>

              <Typography
                color="#3a34eb"
                variant="subtitle2"
                style={{ display: "inline-block" }}
              >
                {startDate + "- " + endDate} <br></br>
              </Typography>

              <Typography color="textPrimary" variant="h6" sx={{ mb: 6 }}>
                Last Transaction Time: {updatedDate.updated_time}
              </Typography>
            </>
          )}
        </CardContent>
      </Card>
    </>
  );
};

export default DateMenu;
